.scope {
    min-height: 0;
}

.cursor-grabbing {
    cursor: grabbing;
}

.cursor-grabbing * {
    cursor: grabbing;
}
